/**
 * @class
 * @classdesc Basic helper functions.
 */
export default class HcsUtilities
{
    constructor() { }

    /**
     * Parse a boolean string where "true" and "1" act as boolean true.
     * @param {string} strBool - Boolean value as string.
     * @returns {bool} Boolean representation fo the given string.
     */
    static parseBoolean(strBool) {
        return strBool && (strBool.toLowerCase() === "true" || strBool === "1");
    }

    /**
     * Gets an URL query parameter.
     * @param {string} name - Name of the parameter.
     * @param {string} [url=window.location.href] - Specify a custom URL where to search for a parameter.
     * When not specified the current browser URL will be used.
     * @returns {string} Value of the given query parameter.
     */
    static getUrlParameterByName(name, url) {
        if(!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if(!results) return null;
        if(!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    /**
     * Return a list of all URL (query) parameters.
     * @param {string} [url=window.location.href] - URL to be parsed.
     * When not specified the current browser URL will be used.
     * @returns {Array} List of all query parameters inside an URL as key/value pair like:
     * {
     *     "param1: "value1",
     *     "param2: "value2",
     *     ...
     * }
     */
    static getUrlParameters(url) {
        var vars = {};

        if(arguments.length < 1) {
            url = window.location.href;
        }

        url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
            vars[key] = value;
        });

        return vars;
    }
}